import React from "react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { Options } from "./Options";

function OptionsControl({
  data,
  id,
  handleChange,
  path,
  label,
  required,
  visible,
  errors,
  rootSchema,
}: ControlProps): JSX.Element {
  const freeTextFields = Object.entries(rootSchema.properties ?? {})
    .filter(([, value]) => {
      return value.type === "string" && value.format === undefined && value.maxLength !== undefined;
    })
    .map(([key]) => key);

  return (
    <Options
      id={id}
      value={data}
      label={label}
      required={required}
      disabled={!visible}
      updateValue={(value: string) => handleChange(path, value)}
      errors={errors}
      freeTextFields={freeTextFields}
    />
  );
}

export default withJsonFormsControlProps(OptionsControl);
